import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { DataManagerDialogsObject } from '@databox/ember-integrations/lib/components/DataManagerDialogs/DataManagerDialogs';
import DataManagerDialogsEntryPoint from '@databox/ember-integrations/lib/components/DataManagerDialogs/DataManagerDialogsEntryPoint';

import type { ReactIntegrations, Service } from 'webapp-types';

/**
 * DataManagerConnectedManagerComponent serves as an integration layer between Ember and React for managing data sources within the application.
 *
 * This component:
 * - Initializes and manages the React-based data source management dialogs
 * - Handles data source delete operation (popUp)
 */
import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';

export default class DataManagerConnectedManagerComponent extends Component {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('data-manager') declare dataManagerService: Service.DataManager;
	@service('react') declare reactService: Service.React;

	reactElement: ReactIntegrations.Root = null;

	@action
	onReactInit(args: DataManagerDialogsObject) {
		this.dataManagerService.dataManagerFunctions = args;
	}

	@action
	setupView(node: HTMLElement) {
		this.reactElement = this.reactService.create(node as HTMLDivElement);

		const { accessToken, userDataToken: dataToken } = this.currentUserService;

		const props = {
			onInit: this.onReactInit,
			accessToken: accessToken!,
			dataToken: dataToken!,
			isDarkThemeActive: this.navigationService.theme.isDark,
			spaceId: this.accountService.id,
		};

		this.reactService.render(this.reactElement, DataManagerDialogsEntryPoint(props));
	}

	@action
	teardownView() {
		this.reactService.unmount(this.reactElement);
	}
	<template>
		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}>
		</div>
	</template>
}
